export default __webpack_public_path__ + "static/media/whyChooseUs.94ac7a76.png";